module.exports = __webpack_public_path__ + "static/media/ls_leds.0bf65e33.jpg";